

export const zeroDollar = '$0.00';

export const addMoney = (a: string, b: string) => {

	if (!a && !b) return zeroDollar;

	if (!a || !b) {
		return a || b;
	}

	const trimmedA = a.replace('$', '').replace(',', '').trim();
	const trimmedB = b.replace('$', '').replace(',', '').trim();

	const result = parseFloat(trimmedA) + parseFloat(trimmedB);

	return `$${result.toFixed(2).toLocaleString()}`;

};